import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { InternshipReportsDataService } from 'common/services/data-services/admin/reports/internship-reports.service';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { InternshipReportsGridMetaModel } from 'common/models/page-models/reports/internship-reports-model/internship-report-grid-meta.model';
import { InternshipReportsModel } from 'common/models/page-models/reports/internship-reports-model/internship-reports-data-model';
import { InternshipReportsListingModel } from 'common/models/page-models/reports/internship-reports-model/internship-reports-grid-model';


@Injectable({
    providedIn: 'root'
})
export class InternshipReportsWidgetService extends GridWidgetService<InternshipReportsModel, InternshipReportsListingModel> {
    constructor(protected override ds: InternshipReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: branchListDataService, private stateService: stateListDataService, private companyListService: CompanyGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new InternshipReportsGridMetaModel().getMetaModel();
        return meta;
    }

    override prepareMetaModel(dataModel: InternshipReportsListingModel, metaModel: InternshipReportsGridMetaModel, routeData: WidgetModel): Promise<InternshipReportsGridMetaModel> {
        return new Promise<InternshipReportsGridMetaModel>((resolve, reject) => {
            
            this.batchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBatch.options = data.details;
            });
            this.branchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBranch.options = data.details;
            });
            this.stateService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedState.options = data.details;
            });
            this.companyListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedCompany.options = data.details;
            });
            const startYear = 2022;
            const presentYear = new Date().getFullYear();
            for (let i = startYear; i <= presentYear; i++) metaModel.filterMeta.properties.selectedYear.options.push({id: i, name: i});
            resolve(metaModel);
        });
    }

}